"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MicrophoneSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M11.27 14.47a4.72 4.72 0 0 0 9.44 0V6.69a4.72 4.72 0 0 0-9.44 0v7.42z"></path><path d="M27 14.41a1.58 1.58 0 0 0-3.16 0 7.84 7.84 0 0 1-15.68 0 1.58 1.58 0 0 0-3.16 0 11 11 0 0 0 9.45 10.81v1.66h-1.59a1.55 1.55 0 1 0 0 3.09h6.28a1.55 1.55 0 1 0 0-3.09h-1.55v-1.67A11 11 0 0 0 27 14.41z"></path><path d="M11 14.47a4.83 4.83 0 0 0 5 4.67 4.85 4.85 0 0 0 5-4.67V6.69A4.85 4.85 0 0 0 16 2a4.83 4.83 0 0 0-5 4.66v7.42z"></path><path d="M27 14.41a1.58 1.58 0 0 0-3.16 0 7.84 7.84 0 0 1-15.68 0 1.58 1.58 0 0 0-3.16 0 11 11 0 0 0 9.45 10.81v1.66h-1.59a1.55 1.55 0 1 0 0 3.09h6.28a1.55 1.55 0 1 0 0-3.09h-1.55v-1.67A11 11 0 0 0 27 14.41z"></path>';
var MicrophoneSVG = function MicrophoneSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MicrophoneSVG = MicrophoneSVG;
MicrophoneSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MicrophoneSVG);
exports.default = _default;